import { useInitPrice as useBcomInitPrice } from '@nuxt-common/media-card-large/app/modules/price/composables/usePrice.bcom';
import { useInitPrice as useMcomInitPrice } from '@nuxt-common/media-card-large/app/modules/price/composables/usePrice';
import type { TraitPrice, TraitPriceBcom } from '@nuxt-common/media-card-large/app/types';

import { useBrand } from '~/composables/useBrand';

/**
 *  useInitPrice parity between mcom / bcom
 */
export function useInitPrice({ id, data }: { id: ProductId; data: TraitPrice | TraitPriceBcom }) {
  const { isMcom } = useBrand();
  const initPrice = isMcom ? useMcomInitPrice : useBcomInitPrice;
  initPrice({ id, data });
}

export default useInitPrice;
